const ERROR_DETAILS_SKIP_KEYS = ['stack'];

const copyErrorDetails = payload => {
  if (!payload || typeof payload !== 'object') return null;

  const keys = [...new Set([...Object.keys(payload), ...Object.getOwnPropertyNames(payload)])];
  const details = keys.reduce((acc, key) => {
    if (ERROR_DETAILS_SKIP_KEYS.includes(key)) return acc;

    const value = payload[key];
    if (value !== undefined) {
      acc[key] = value;
    }

    return acc;
  }, {});

  if (payload.name && !details.name) details.name = payload.name;
  if (payload.message && !details.message) details.message = payload.message;

  return Object.keys(details).length ? details : null;
};

export const stringifyErrorDetails = payload => {
  if (!payload || typeof payload === 'string') return '';

  const errorDetails = copyErrorDetails(payload) || payload;

  try {
    return JSON.stringify(errorDetails, null, 2) || '';
  } catch {
    return JSON.stringify({ message: 'Failed to serialize error details' }, null, 2);
  }
};
